import ImagesIconsSettingsAddressSvg from '@/public/images/icons/settings/address.svg';
import ImagesIconsSettingsCheckSvg from '@/public/images/icons/settings/check.svg';
import ImagesIconsSettingsCloseAccountSvg from '@/public/images/icons/settings/close-account.svg';
import ImagesIconsSettingsContactSvg from '@/public/images/icons/settings/contact.svg';
import ImagesIconsSettingsDeleteAccountSvg from '@/public/images/icons/settings/delete-account.svg';
import ImagesIconsSettingsDhlSvg from '@/public/images/icons/settings/dhl.svg';
import ImagesIconsSettingsFilterSvg from '@/public/images/icons/settings/filter.svg';
import ImagesIconsSettingsHelpCenterSvg from '@/public/images/icons/settings/help-center.svg';
import ImagesIconsSettingsInfoSvg from '@/public/images/icons/settings/info.svg';
import ImagesIconsSettingsInfoWhiteSvg from '@/public/images/icons/settings/infoWhite.svg';
import ImagesIconsSettingsNotificationsSvg from '@/public/images/icons/settings/notifications.svg';
import ImagesIconsSettingsPasswordSvg from '@/public/images/icons/settings/password.svg';
import ImagesIconsSettingsPaymentMethodSvg from '@/public/images/icons/settings/payment-method.svg';
import ImagesIconsSettingsProfessionalSellerSvg from '@/public/images/icons/settings/professional-seller.svg';
import ImagesIconsSettingsShippingSvg from '@/public/images/icons/settings/shipping.svg';
import ImagesIconsSettingsSuccessSvg from '@/public/images/icons/settings/success.svg';
import ImagesIconsSettingsTwoFactorSvg from '@/public/images/icons/settings/two-factor.svg';

export {
  ImagesIconsSettingsAddressSvg,
  ImagesIconsSettingsCheckSvg,
  ImagesIconsSettingsCloseAccountSvg,
  ImagesIconsSettingsContactSvg,
  ImagesIconsSettingsDeleteAccountSvg,
  ImagesIconsSettingsDhlSvg,
  ImagesIconsSettingsFilterSvg,
  ImagesIconsSettingsHelpCenterSvg,
  ImagesIconsSettingsInfoSvg,
  ImagesIconsSettingsInfoWhiteSvg,
  ImagesIconsSettingsNotificationsSvg,
  ImagesIconsSettingsPasswordSvg,
  ImagesIconsSettingsPaymentMethodSvg,
  ImagesIconsSettingsProfessionalSellerSvg,
  ImagesIconsSettingsShippingSvg,
  ImagesIconsSettingsSuccessSvg,
  ImagesIconsSettingsTwoFactorSvg,
};
